import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    inscritos:[],
    referencia: null
  },
  getters: {
    getInscritos(state) {
      return state.inscritos
    }
  },
  mutations: {
    addPerson (state, person) {
      state.inscritos.push( person )
    },
    delPerson (state, position) {
      state.inscritos.splice(position, 1)
    },
    addReference (state, reference) {
      state.referencia = reference
    },
    delReference (state) {
      state.referencia = null
    }
  },
  actions: {
    addPerson ( {commit, state}, person ) {
      const existe = state.inscritos.find( persona => persona.dni.toUpperCase() === person.dni.toUpperCase() )
      if (existe) return { error: true, msg:'No se pueden inscribir dos personas con el mismo DNI.'}
      if (state.inscritos.length < 10)
        commit('addPerson', person)
      else return { error: true, msg:'No se pueden inscribir más de 10 corredores de una sola vez.'}
      return { inscritos: state.inscritos.length }
    },
    delPerson ( {commit, state}, dni) {
      const position = state.inscritos.findIndex( persona => persona.dni.toUpperCase() === dni.toUpperCase())
      if (position != -1)
        commit ('delPerson', position )
      else return null
    },
    addChild ( {commit, state}, person ) {
      if (state.inscritos.length < 10)
        commit('addPerson', person)
      else return { error: true, msg:'No se pueden inscribir más de 10 corredores de una sola vez.'}
      return { inscritos: state.inscritos.length }
    },
    delChild ( {commit, state}, position) {
      if (state.inscritos.length > 0) {
        commit( 'delPerson', position)
      }
    },
    addReference ( {commit, state}, reference) {
      if (state.referencia !== null)
        return {error: true, msg: 'Esta inscripcioón ya tiene una referencia asignada', referencia: state.referencia }
      commit('addReference', reference)
      return { referencia: state.referencia }
    },
    delReference ( {commit}) {
      commit('delReference')
    }
  }
})
